import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ButtonSize, ButtonTypes } from '@shared/modules/ui/components/button/button.component';

@Component({
  selector: 'list-single-clear-filters-v2',
  templateUrl: './list-single-clear-filters-v2.component.html',
})
export class ListSingleClearFiltersV2Component {
  @Input() form: UntypedFormGroup;
  @Input() shouldShowClearFilters?: Function;
  @Input() clearFilters?: Function;
  @Output() change: EventEmitter<any> = new EventEmitter();

  ButtonSize = ButtonSize;
  ButtonTypes = ButtonTypes;

  constructor() {}

  get showClearFilters() {
    if (this.shouldShowClearFilters) {
      return this.shouldShowClearFilters();
    }

    let show = false;
    Object.keys(this.form.value).forEach((key) => {
      if (this.form.value[key]) {
        show = true;
      }
    });
    return show;
  }

  clear() {
    if (this.clearFilters) {
      this.clearFilters();
    } else {
      Object.keys(this.form.value).forEach((key) => {
        this.form.get(key).setValue(null);
      });
    }
    this.change.emit();
  }
}
